document.addEventListener("DOMContentLoaded", function () {
  const loadMoreBtn = document.querySelector(".js-load-more");
  const productGrid = document.querySelector("[data-product-grid]");
  const totalCountEl = document.getElementById("total-count");
  const shownCountEl = document.getElementById("shown-count");
  const progressBar = document.getElementById("progress-bar");
  const progressWrapper = document.getElementById("progress-wrapper");

  // Lock the total at first paint
  const totalCount = parseInt(totalCountEl?.textContent || "0", 10);

  if (!productGrid) return;

  // Helper: get unique product handles currently in the grid
  function getUniqueShownCount() {
    // Prefer data attributes if your cards have them; fall back to href parsing
    const handles = new Set();

    // If your theme adds data-product-handle on each card, use that:
    productGrid.querySelectorAll("[data-product-handle]").forEach((el) => {
      const h = el.getAttribute("data-product-handle");
      if (h) handles.add(h);
    });

    // Fallback: parse product handle from product links
    if (handles.size === 0) {
      productGrid.querySelectorAll('.product-card a[href*="/products/"]').forEach((a) => {
        try {
          const url = new URL(a.href, window.location.origin);
          // /products/<handle> or /products/<handle>?...
          const parts = url.pathname.split("/");
          const idx = parts.indexOf("products");
          if (idx !== -1 && parts[idx + 1]) handles.add(parts[idx + 1]);
        } catch (e) {}
      });
    }

    // Last resort: count only top-level cards (avoids nested/placeholder nodes)
    if (handles.size === 0) {
      const topLevelCards = Array.from(productGrid.children).filter((n) =>
        n.classList?.contains("product-card") || n.querySelector?.(".product-card")
      );
      return topLevelCards.length;
    }

    return handles.size;
  }

  function updateProgress() {
    const currentShown = getUniqueShownCount();

    if (shownCountEl) shownCountEl.textContent = String(currentShown);
    if (totalCountEl) totalCountEl.textContent = String(totalCount);

    if (progressWrapper) progressWrapper.style.display = "block";

    if (progressBar && totalCount > 0) {
      const percent = Math.min((currentShown / totalCount) * 100, 100);
      progressBar.style.width = percent + "%";
      progressBar.style.display = "block";
    }
  }

  updateProgress(); // initial

  if (!loadMoreBtn) return;

  // ---- Infinite scroll trigger (auto-click when button hits viewport) ----
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting && loadMoreBtn) {
          loadMoreBtn.click();
        }
      });
    },
    { rootMargin: "300px 0px 0px 0px" } // preload before the button fully appears
  );
  io.observe(loadMoreBtn);

  loadMoreBtn.addEventListener("click", function () {
    const nextUrl = loadMoreBtn.getAttribute("data-next-url");
    if (!nextUrl) return;

    loadMoreBtn.textContent = "Loading...";

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newProductGrid = doc.querySelector("[data-product-grid]");
        const newCards =
          newProductGrid?.querySelectorAll(".product-card") || [];

        if (newCards.length === 0) {
          io.unobserve(loadMoreBtn);
          loadMoreBtn.remove();
          updateProgress();
          return;
        }

        newCards.forEach((card) => productGrid.appendChild(card));

        // Update counts/progress AFTER append
        updateProgress();

        const nextBtn = doc.querySelector(".js-load-more");
        if (nextBtn && nextBtn.hasAttribute("data-next-url")) {
          loadMoreBtn.setAttribute(
            "data-next-url",
            nextBtn.getAttribute("data-next-url")
          );
          loadMoreBtn.textContent = "Load more →";
        } else {
          // No next page
          io.unobserve(loadMoreBtn);
          loadMoreBtn.style.opacity = "0";
          setTimeout(() => loadMoreBtn.remove(), 300);
        }
      })
      .catch((err) => {
        console.error("Load more failed:", err);
        loadMoreBtn.textContent = "Error. Try again.";
      });
  });
});
